// extracted by mini-css-extract-plugin
export default {"title":"wKZ19NllX_","button":"sKi3mVTGzB"};